/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
(function () {

  // 変数
  var rul = {};
  var msg = {};
  var glp = {};

  // グローバル変数　※先にjs/validation/common.jsを読み込んでおく
  var getMsg = window.ohValidateGetMsg;
  var changeBlank = window.ohValidateChangeBlank;
  var changeHankaku = window.ohValidateChangehankaku;
  var contactWayList = window.ohValidateContactWay;
  var serviceList = window.ohValidateService;

  // エラーメッセージグループ
  var glpStrContactWayList = '';
  $.each(contactWayList, function(k, v){
    glpStrContactWayList = glpStrContactWayList + 'contact_way[' + k + '] ' ;
  })
  var glpStrServiceList = '';
  $.each(serviceList, function(k, v){
    glpStrServiceList = glpStrServiceList + 'service[' + k + '] ' ;
  })
  glp['contact_way'] = $.trim( glpStrContactWayList );
  glp['service'] = $.trim( glpStrServiceList );

  // お名前
  rul['customer_nm'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['customer_nm'] = {
    required:getMsg('required','名前'),
    maxlength:getMsg('max.string', '名前', {'max' : '40'}),
  };

  // ふりがな
  rul['customer_kn'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['customer_kn'] = {
    required:getMsg('required','ふりがな'),
    kana:getMsg('kana2'),
    maxlength:getMsg('max.string', 'ふりがな', {'max' : '40'})
  };

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['customer_email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['customer_email'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // トリム,空白,半角に自動変換
  // 電話番号
  rul['customer_tel_no'] = {
    required: {
      depends:function(){
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['customer_tel_no'] = {
    required:getMsg('required','電話番号',),
    regex:getMsg('regex','電話番号'),
    maxlength:getMsg('max.string', '電話番号', {'max' : 13}),
  };

  // 配信停止理由
  var requireServiceFlg = function(){
    var b = false;
    $.each(serviceList, function(k, v){
      b = b || $('#service' + k).prop('checked');
    })
    return !b;
  };
  $.each(serviceList, function(k, v){
    rul['service[' + k + ']'] = {digits: true, required:{depends: function(){return requireServiceFlg();}}};
    msg['service[' + k + ']'] = {
      digit:getMsg('in'),
      required: getMsg('required_without_all','お問合せ・ご利用希望サービス')
    };
  })

  // ご希望のご連絡方法
  var requireContactWayFlg = function(){
    var b = false;
    $.each(contactWayList, function(k, v){
      b = b || $('#contact_way' + k).prop('checked');
    })
    return !b;
  };
  $.each(contactWayList, function(k, v){
    rul['contact_way[' + k + ']'] = {digits: true, required:{depends: function(){return requireContactWayFlg();}}};
    msg['contact_way[' + k + ']'] = {
      digit:getMsg('in'),
      required: getMsg('required_without_all','当社からのご希望の連絡方法')
    };
  })

  // その他
  rul['consult_txt'] = { maxlength: 1000 };
  msg['consult_txt'] = { maxlength:getMsg('max.string', 'その他', {'max' : '1000'})};

  // 個人情報保護方針（プライバシー・ポリシー）
  rul['privacy_policy'] = {required: true,};
  msg['privacy_policy'] = {
    required:getMsg('required','個人情報保護方針（プライバシー・ポリシー）'),
  };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {
  // お客様情報
  $(".contact_way-group").on('change', function() {
    $("#contact_way1").valid();
  });
}());
